module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya_ekimae/nagoya_ekimae_concept_01-c25c017cb22d3b2f8073f54a7a71fc87.jpg";